import axios from 'axios'
// import qs from 'qs'
import { Toast } from 'vant'
import { storage } from '@/store/local'
import router from '@/router/index'
import global from './global'

const WHITE_LIST_URL = [] // 不需要存储token
const REQUEST_TOKEN_URL = [ // 不需要传递token
  '/app/user/v1.0.0/auth_login'
]

const $token = 'x-user-token'

const request = axios.create({
  baseURL: global.baseURL
})

// 请求拦截器===  在发送请求之前
request.interceptors.request.use(function (config) {
  if (!config.data && config.method === 'post') {
    config.data = {}
  }
  if (config.data) {
    if (!config.data.source) {
      config.data.source = 'H5' // (storage.get('entranceData') || {}).source
    }
    if (!config.data.appId) {
      config.data.appId = 'H5'
    }
  }

  if (!REQUEST_TOKEN_URL.includes(config.url)) {
    const userToken = storage.getToken()
    if (userToken) {
      config.headers['X-user-token'] = userToken
    }
  }
  return config
}, function (error) { // 请求错误
  // Toast(error.errMsg || '请求错误')
  return Promise.reject(error)
})

// 响应拦截器
request.interceptors.response.use(function (response) {
  if (response.data.code === '9990' || response.data.code === '-9990') { // 用户认证失败
    storage.logout()
    Toast.fail(response.data.message || '登录失效')
    return router.replace({ path: '/login' })
  }
  if (+response.data.code !== 1) {
    // const messageText = (response.data && response.data.message && (response.data.message.length < 20)) ? response.data.message : '请求错误'
    // Toast.fail(messageText)
    console.error('响应异常：', response)
    return response.data
  }
  const token = response.headers[$token]
  if (!WHITE_LIST_URL.includes(response.config.url) && token) {
    storage.setToken(token)
  }

  return response.data
}, function (error) {
  console.log('网络错误 error::: ', error)
  return Promise.reject(error)
})

// parseUrlWithArgs('/api/aeDocmentTypes/create/{AA}', {AA:888888})
// '/api/aeDocmentTypes/create/888888'
function parseUrlWithArgs (url, args = {}) {
  const reg = /{([a-zA-Z0-9]*)}/
  while (reg.exec(url)) {
    const match = reg.exec(url)
    const key = match[1]
    const val = args[key]
    const placeholder = match[0]
    url = url.replace(new RegExp(placeholder), val)
  }
  return url
}

export { request, parseUrlWithArgs }



// WEBPACK FOOTER //
// ./src/utils/request.js